module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt3_en.2daee7a5b3f94c4eb1a9ec612f2ef5c1.png";